import { Controller } from 'stimulus';
export default class extends Controller {
  static targets = ["itemOrderSelect"]
  
  loadItemOrders(event) {
    const itemId = event.target.value
    const itemOrderSelect = this.itemOrderSelectTarget
    
    // Clear existing options
    itemOrderSelect.innerHTML = '<option value="">Loading...</option>'
    
    if (!itemId) {
      itemOrderSelect.innerHTML = '<option value="">Select an item first...</option>'
      return
    }
    
    // Extract task ID from URL: app.limsey.com/jobs/27946/tasks/103565?nav=equipment_inventory&pannel=inventory
    const pathParts = window.location.pathname.split('/')
    const taskId = pathParts[4] // jobs is index 1, job_id is index 2, tasks is index 3, task_id is index 4
    
    // console.log('Task ID from URL:', taskId)
    // console.log('Full path parts:', pathParts)
    
    // Fetch item orders
    fetch(`/tasks/${taskId}/task_item_uses/item_orders?item_id=${itemId}`)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        itemOrderSelect.innerHTML = '<option value="">Select an item order...</option>'
        data.forEach(order => {
          const option = document.createElement('option')
          option.value = order.id
          option.textContent = order.display_text
          itemOrderSelect.appendChild(option)
        })
      })
      .catch(error => {
        console.error('Error:', error)
        itemOrderSelect.innerHTML = '<option value="">Error loading orders</option>'
      })
  }
}